import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React from 'react'; // import { Input } from 'semantic-ui-react'

import { Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { InputFeedback, Input } from '@dmi-mch/components';
import { isStringFoundInString } from '@dmi-mch/utils';
import styled from 'styled-components';
/**
 * This Component receives a string of emails separated by commas, and shows them inside baloons.
 * It also allows adding new emails to the list of baloons, and validates that the input data is
 * an email.
 * @param {*} defaultValue The string of emails when initializing the component.
 * @param {*} fieldName The field to update in the parent form
 * @param {*} listChangedCallback is used to pass a callback for after the submit of new email
 */
// Adding an extra validator, imported.

Yup.addMethod(Yup.string, 'isStringFoundInString', isStringFoundInString); // The component

var EmailsInput = function EmailsInput(props) {
  // For the default value, split and trim. Trimming just in case.
  var _React$useState = React.useState(props.defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      stringsList = _React$useState2[0],
      setStringsList = _React$useState2[1];

  var removeEmail = function removeEmail(email) {
    var newStringsArray = stringsList.split(',');
    var index = newStringsArray.indexOf(email);
    if (index !== -1) newStringsArray.splice(index, 1);
    var str = newStringsArray.join(',');
    setStringsList(str);

    if (typeof props.listChangedCallback === 'function') {
      props.listChangedCallback(props.fieldName, str);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: props.className
  }, stringsList && stringsList.split(',').map(function (email) {
    return /*#__PURE__*/React.createElement("span", {
      key: email
    }, email, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return removeEmail(email);
      }
    }, " X "));
  }), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      email: ''
    },
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;

      /* This goes on as soon as e-mail:
      is filled in, is a correct email, is not duplicated (more info in validationSchema)
      */
      var resultingString = "".concat(stringsList && "".concat(stringsList, ",")).concat(values.email);
      setStringsList(resultingString);
      props.listChangedCallback(props.fieldName, resultingString);
      resetForm();
    },
    validationSchema: function validationSchema() {
      var schema = {
        email: Yup.string().required('Please enter a valid e-mail').email('This e-mail is not valid').isStringFoundInString(stringsList, 'This email already exists')
      };
      return Yup.object().shape(schema);
    }
  }, function (subformik) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
      placeholder: "Add a valid email address and press Enter" // Amazing world of the FE. Put this to hide the chrome suggestions
      ,
      autoComplete: "new-password",
      type: "text",
      value: subformik.values.email,
      name: "email",
      onChange: subformik.handleChange,
      onBlur: function onBlur() {
        return subformik.resetForm();
      },
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          subformik.submitForm();
        }
      },
      error: subformik.errors.email && subformik.touched.email,
      disabled: props.disabled
    }), subformik.errors.email && subformik.touched.email && /*#__PURE__*/React.createElement(InputFeedback, null, subformik.errors.email));
  }));
};

EmailsInput.propTypes = {
  handleSubmit: PropTypes.func,
  values: PropTypes.object,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  listChangedCallback: PropTypes.func,
  fieldName: PropTypes.string,
  disabled: PropTypes.bool
};
var EmailsInputStyled = styled(EmailsInput).withConfig({
  displayName: "EmailsInput__EmailsInputStyled",
  componentId: "sc-1uaz82b-0"
})(["padding:6px 6px 6px;border:1px solid #d0d0d0;background:white;small{position:absolute;margin-top:0px;background:white;border:1px solid red;line-height:15px;}div{display:inline-block;.ui.input{display:inline;input{padding:5px 0px;border:none;width:305px !important;}small{margin:0 0 0 10px;display:inline;}}}span{background:#efefef;border-radius:8px;font-size:14px;padding:4px 7px;margin:0px 8px 5px 0px;display:inline-block;button{border:none;background:transparent;cursor:pointer;color:#757575;font-size:10px;}}button[type='button']{visibility:hidden;}"]);
export default EmailsInputStyled;